export const POST_LOGIN = "/auth/login";
export const POST_VERIFY_LOGIN_OTP = "/auth/verify-login-otp";
export const POST_RESEND_LOGIN_OTP = "/auth/resend-login-otp";
export const POST_CHANGE_PASSWORD = "/auth/change-password";
export const GET_AUTH_ME = "/auth/me";
export const DASHBOARD_OVERVIEW = "/dashboard/overview";


// ==================================  URL ===================================================
//

export const ORGANIZATIONS = "/organizations";
export const SURPLUS_PACKAGE = "/surplus-packages";
export const BUILDINGS = "/buildings";
export const UNITS = "/units";
export const TENANTS = "/tenants";
export const LEASES = "/leases";
export const MAINTENANCE = "/maintenance";
export const EMPLOYEES = "/employees";
export const UTILITY_TYPES = "/utility-types";
export const FINANCE = "/finance";


// ================================== END OF  URL ===================================================
